import { Step, Stepper, StepLabel, StepConnector, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { stepConnectorClasses } from '@mui/material/StepConnector';
import React from 'react';
import { theme } from '../../../theme';
import { Stack } from '@mui/system';
import { CheckCircleOutline, NavigationOutlined } from '@mui/icons-material';
import { NumericFormat } from 'react-number-format';


const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: theme.palette.green.taskText,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: theme.palette.green.taskText,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 5,
        border: 0,
        backgroundColor: theme.palette.background.unreviewedProgress,
        borderRadius: 4,
        top: '-3px',
    },
}));

function NewCampaignProgressBar(props) {
    return (
        <Stack spacing={2}>
            <Stepper alternativeLabel connector={<CustomConnector/>}>
                {props.steps.map((step) => (
                    <Step key={step.label} completed={step.completed}>
                        <StepLabel StepIconProps={{
                            style: {
                                color: step.completed ? theme.palette.green.taskText : theme.palette.background.unreviewedProgress,
                            }
                        }} sx={{ padding: '0px' }}>
                            <Typography variant='normal' fontSize='12px'>{step.label}</Typography>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
            { !props.hasTopDraftsReviewed && <SupportingText step={0} campaignOpportunity={props.campaignOpportunity} numUnreviewedCardsWithOptmizations={props.numCardsWithOptimizationsRemaining} /> }
            { props.hasTopDraftsReviewed && props.numCardsWithOptimizationsRemaining > 0 && <SupportingText step={1} numUnreviewedCardsWithOptmizations={props.numCardsWithOptimizationsRemaining} /> }
            { props.hasTopDraftsReviewed && props.numCardsWithOptimizationsRemaining === 0 && props.numCardsRemaining > 0 && <SupportingText step={2} numUnreviewedCards={props.numCardsRemaining} /> }
            { props.hasTopDraftsReviewed && props.numCardsWithOptimizationsRemaining === 0 && props.numCardsRemaining === 0 && <SupportingText step={3} /> }
        </Stack>
    );  
}

function SupportingText(props) {
    if (props.step === 0) {
        return (
            <Stack spacing={1}>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <NavigationOutlined fontSize='small' sx={{ transform: 'rotate(90deg)' }} />
                    <Typography variant='normal' fontSize='12px'>
                        <b>{props.numUnreviewedCardsWithOptmizations} Unreviewed Cards</b> with optimizations remain at this facility
                    </Typography>
                </Stack>
                { props.campaignOpportunity > 100 &&
                    <Stack direction='row' spacing={0.5} alignItems='center'>
                        <NavigationOutlined fontSize='small' sx={{ transform: 'rotate(90deg)' }} />
                        <Typography variant='normal' fontSize='12px'>
                            <b><NumericFormat value={props.campaignOpportunity / 100} prefix={'$'} displayType={'text'} thousandSeparator={true} decimalScale={0} fixedDecimalScale={true} /> in DOCSI-Identified Opportunity</b> at this facility
                        </Typography>
                    </Stack>
                }
            </Stack>
        );
    } else if (props.step === 1) {
        return (
            <Stack spacing={1}>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <CheckCircleOutline fontSize='small' />
                    <Typography variant='normal' fontSize='12px'>
                        You've reviewed your <b>Top Cards</b> at this facility
                    </Typography>
                </Stack>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <NavigationOutlined fontSize='small' sx={{ transform: 'rotate(90deg)' }} />
                    <Typography variant='normal' fontSize='12px'>
                        <b>{props.numUnreviewedCardsWithOptmizations} Unreviewed Cards</b> with optimizations remain
                    </Typography>
                </Stack>
            </Stack>
        );
    } else if (props.step === 2) {
        return (
            <Stack spacing={1}>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <CheckCircleOutline fontSize='small' />
                    <Typography variant='normal' fontSize='12px'>
                        No remaining <b>DOCSI-Identified Optimizations</b> available at this facility. Please review remaining cards to make other desired changes
                    </Typography>
                </Stack>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <NavigationOutlined fontSize='small' sx={{ transform: 'rotate(90deg)' }} />
                    <Typography variant='normal' fontSize='12px'>
                        <b>{props.numUnreviewedCards} Unreviewed Cards</b> at this facility
                    </Typography>
                </Stack>
            </Stack>
        )
    } else if (props.step === 3) {
        return (
            <Stack spacing={1}>
                <Stack direction='row' spacing={0.5} alignItems='center'>
                    <CheckCircleOutline fontSize='small' />
                    <Typography variant='normal' fontSize='12px'>
                        You've reviewed <b>All Cards</b> at this facility
                    </Typography>
                </Stack>
            </Stack>
        );
    }
    return <></>;
}

export default NewCampaignProgressBar;
